import { Modal, Button } from "@thetreep/ui";
import { useTranslation } from "react-i18next";
interface ConfirmDeleteAccountModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  isLoading: boolean;
}

export function ConfirmDeleteAccountModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}: ConfirmDeleteAccountModalProps) {
  const { t } = useTranslation();

  return (
    <Modal size="default" isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col gap-4">
        <span className="font-jakarta font-bold text-text-strong text-md">
          {t("settings.gdpr.deleteAccountConfirmation.title")}
        </span>
        <div>
          <p className="font-roboto text-text-strong">
            {t("settings.gdpr.deleteAccountConfirmation.text")}
          </p>
        </div>
        <div className="flex gap-2 justify-end">
          <Button onClick={onClose} kind="outline" size="compact">
            {t("settings.gdpr.deleteAccountConfirmation.cancel")}
          </Button>
          <Button onClick={onConfirm} size="compact" isLoading={isLoading}>
            {t("settings.gdpr.deleteAccountConfirmation.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
